import { ClaimTabs } from "./ClaimTabs";

export class NullClaimTabs implements ClaimTabs {
    clearContentTabLink(): void {
        /* do nothing */
    }

    updateContentTabLink(_selectedContentId?: number): void {
        /* do nothing */
    }
}
